import { render, staticRenderFns } from "./Keshi_sxJianding2.vue?vue&type=template&id=5ca0489c&scoped=true&"
import script from "./Keshi_sxJianding2.vue?vue&type=script&lang=js&"
export * from "./Keshi_sxJianding2.vue?vue&type=script&lang=js&"
import style0 from "./Keshi_sxJianding2.vue?vue&type=style&index=0&id=5ca0489c&prod&lang=less&"
import style1 from "./Keshi_sxJianding2.vue?vue&type=style&index=1&id=5ca0489c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0489c",
  null
  
)

export default component.exports